import React from "react";
import SetTitle from "../../components/SetTitle";
import styles from "./Message.module.scss";

const Message = () => {
	SetTitle("Message");

	return (
		<div className={styles.Message}>
			<div className={styles.Container}>
				<h2>Principal Message</h2>
				<span></span>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas
					tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit.
					Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit
					amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt
					cras. Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
					mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum
					dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique
					tincidunt cras. Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur
					curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor
					sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique
					tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis
					ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit amet,
					consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
					Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut
					curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit
					amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt
					cras. Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
					Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit.
				</p>
			</div>
			<div className={styles.Container}>
				<h2>Director's Message</h2>
				<span></span>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas
					tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit.
					Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit
					amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt
					cras. Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
					mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum
					dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique
					tincidunt cras. Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur
					curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor
					sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique
					tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis
					ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit amet,
					consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
					Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut
					curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit
					amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt
					cras. Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
					Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit.
				</p>
			</div>
		</div>
	);
};

export default Message;
